import { render } from "./CarouselSlide.vue?vue&type=template&id=2e203198"
import script from "./CarouselSlide.vue?vue&type=script&lang=js"
export * from "./CarouselSlide.vue?vue&type=script&lang=js"

import "./CarouselSlide.vue?vue&type=style&index=0&id=2e203198&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__